<template>
  <base-icon-button v-on="$listeners"
                    :title="title">
    <base-material-design-icon icon="people"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonPeople',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        default: 'Team form',
        validator: (value) => value.length > 0,
      },
    },
  };
</script>

<style scoped>

</style>
